<mat-checkbox (change)="change(checkbox.checked)" #checkbox>
  {{ label }}
</mat-checkbox>